import axiosInstance from '../utils/axiosConfig';

export interface Settlement {
  id: number;
  name: string;
  region_id?: number;
  region?: {
    id: number;
    name: string;
    country_id: number;
  };
}

export const listSettlements = async (regionId?: number) => {
  const params = regionId ? { region_id: regionId } : {};
  const { data } = await axiosInstance.get<Settlement[]>('/api/v1/settlements', { params });
  return data;
}; 